import { Injectable, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { z } from 'zod';

export type LegalPageKey =
  | 'provider'
  | 'legal-notice'
  | 'privacy-statement'
  | 'settings'
  | 'terms-of-use'
  | 'accessibility';

const LegalPageSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    body: z.string(),
    url_slug: z.string(),
  })
  .transform((data) => {
    return {
      id: data.id,
      title: data.title,
      body: data.body,
      bypassedBody: '' as SafeHtml,
      slug: data.url_slug.replace('/static-page/', '') as LegalPageKey,
    };
  });
export type LegalPage = z.infer<typeof LegalPageSchema>;

@Injectable({
  providedIn: 'root',
})
export class LegalAdapter {
  private sanitizer = inject(DomSanitizer);

  public parse(data: any): LegalPage {
    const parsed = LegalPageSchema.safeParse(data);
    if (parsed.success) {
      parsed.data.bypassedBody = this.sanitizer.bypassSecurityTrustHtml(parsed.data.body);
      return parsed.data;
    } else {
      throw parsed.error;
    }
  }
}
